import { getDefaultByType } from './workcellFormUtils';
import { DriverSchema, FieldValue } from '../types';

export const enrichConfig = (
  config: Record<string, FieldValue>,
  schema: DriverSchema
): Record<string, FieldValue> => {
  const enriched = { ...config };

  for (const [key, meta] of Object.entries(schema)) {
    if (!(key in enriched)) {
      const value =
        meta.default === 'NO_DEFAULT'
          ? getDefaultByType(meta.type)
          : meta.default ?? getDefaultByType(meta.type);
      enriched[key] = value as FieldValue;
    }
  }

  return enriched;
};
